import { useNavigate } from 'react-router-dom';
import { SearchX } from 'lucide-react';

/* ═══════════════════════════════════════════════════════════════════════
   PAGE INTROUVABLE

   Ce que voit quelqu'un qui ouvre une adresse fermée à son rôle.

   « Accès refusé » aurait été plus bavard — et c'est justement le
   problème : ce message confirme que la page existe, qu'elle contient
   quelque chose, et que d'autres y ont droit. Quand une zone est fermée
   à un rôle, elle ne figure pas dans son menu ; pour lui, elle n'existe
   pas. L'écran et le serveur tiennent donc le même discours, et le
   serveur répond bien 404, pas 403.

   Le même écran sert aussi aux adresses réellement inexistantes — une
   faute de frappe, un lien périmé. C'est voulu : rien ne doit permettre
   de distinguer les deux cas de l'extérieur.
   ═══════════════════════════════════════════════════════════════════════ */

export default function PageIntrouvable() {
  const navigate = useNavigate();
  return (
    <div className="flex-1 grid place-items-center px-5 py-16">
      <div className="max-w-md text-center">
        <span className="w-[52px] h-[52px] mx-auto mb-4 rounded-controle grid place-items-center
                         bg-[var(--bg-card)] shadow-carte text-[var(--text-muted)]">
          <SearchX className="w-6 h-6" strokeWidth={1.6} />
        </span>
        <h1 className="titre-carte">Page introuvable</h1>
        <p className="mt-2 text-[13.5px] text-[var(--text-muted)] leading-relaxed">
          Cette adresse ne correspond à aucune page de votre espace.
          Vérifiez le lien, ou repartez du menu.
        </p>
        <button type="button" onClick={() => navigate('/')} className="act mt-5">
          Revenir à l’accueil
        </button>
      </div>
    </div>
  );
}
